import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import RightSidebar from "./RightSidebar";
import {
  SessionContext,
  getSessionCookie,
  setSessionCookie,
} from "./session.ts";
class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      session: null,
      emailAddress: "",
      showSidebar: false,
    };
  }

  componentDidMount() {
    var page = this;

    page.setState({ session: getSessionCookie() }, () => {
      if (page.state.session != null) {
        page.setState({ emailAddress: page.state.session["emailAddr"] });
      }
    });
  }

  sidebarOpenHandler = () => this.setState({ showSidebar: true });
  sidebarCloseHandler = () => this.setState({ showSidebar: false });

  render() {
    var page = this;
    return (
      <div id="kt_header" className="header flex-column header-fixed">
        <div className="header-top">
          <div className="container">
            <div className="d-none d-lg-flex align-items-center mr-3">
              <NavLink to="/" className="mr-20">
                <img
                  alt="Logo"
                  src="/assets/media/layout/PCNA_Logo_RGB_FINAL_TM_LIGHT.png"
                  className="max-h-35px"
                />
              </NavLink>
              <ul
                className="header-tabs nav align-self-end font-size-lg"
                role="tablist"
              >
                <li className="nav-item">
                  <NavLink
                    strict
                    to="/home"
                    className="nav-link py-4 px-6"
                    activeClassName="active"
                  >
                    Quotes
                  </NavLink>
                </li>
                {/* {data-toggle="tab"} */}
                <li className="nav-item mr-3">
                  <NavLink
                    strict
                    to="/masters"
                    className="nav-link py-4 px-6"
                    activeClassName="active"
                  >
                    Masters
                  </NavLink>
                </li>
              </ul>
            </div>
            <div className="topbar">
              <div className="topbar-item">
                <div
                  className="btn btn-icon btn-hover-transparent-white w-sm-auto d-flex align-items-center btn-lg px-2"
                  //id="kt_quick_user_toggle"
                  onClick={this.sidebarOpenHandler.bind(this)}
                >
                  <div className="d-flex flex-column text-right pr-sm-3">
                    <span className="text-white opacity-50 font-weight-bold font-size-sm d-none d-sm-inline">
                      {page.state.emailAddress}
                    </span>
                    <span className="text-white font-weight-bolder font-size-sm d-none d-sm-inline">
                      LOD System User
                    </span>
                  </div>
                  <span className="symbol symbol-35">
                    <span className="symbol-label font-size-h5 font-weight-bold text-white bg-white-o-30">
                      {page.state.emailAddress[0]}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        {page.props.children}
        <RightSidebar
          emailAddress={this.state.emailAddress}
          sessionLogout={this.props.sessionLogout}
          show={this.state.showSidebar}
          onClose={this.sidebarCloseHandler.bind(this)}
        />
      </div>
    );
  }
}
export default withRouter(Header);
